<script setup>
import { computed } from "vue";
import BaseDataTable from "@/javascript/views/components/charts/BaseDataTable.vue";
import { useUserStore } from "@/javascript/stores/user";

const userStore = useUserStore();

const labels = [
  { label: "Organization Name", key: "organization_name" },
  { label: "Campaign Name", key: "campaign_name" },
  { label: "Fund Name", key: "fund_name" },
  { label: "Amount", key: "amount",       format: "money" },
  { label: "Payment Type", key: "payment_type" },
  { label: "Type", key: "type" },
  { label: "Gift Date", key: "date", format: "date" },
];

const rows = computed(() =>
  (userStore.donations || [])
    .filter(d => d.status === "completed")
    .sort((a, b) => new Date(b.paid_at || 0) - new Date(a.paid_at || 0))
    .slice(0, 25)
    .map(d => ({
      organization_name: d.organization_name || "—",
      campaign_name: d.campaign_name || d.donatable?.name || d.donatable?.campaign_name || "—",
      fund_name: d.fund_name || d.donatable?.name || d.donatable?.fund_name || "—",
      amount: d.amount,
      payment_type:
        d.processor_type?.includes("Stripe") ? "Stripe" :
          d.processor_type?.includes("Helcim") ? "Helcim" :
            (d.processor_type || "—"),
      type: d.subscription ? "Recurring" : "One-time",
      date: d.paid_at,
    }))
);
</script>

<template>
  <div class="border border-slate-200 rounded-lg shadow p-4 bg-white">
    <div class="text-sm font-semibold text-gray-900 mb-1">
      Recent Activity
    </div>
    <div class="text-xs text-gray-500 mb-3">
      Your recent giving and account activity.
    </div>
    <div class="ra-scroll">
      <BaseDataTable
        :loading="!userStore.user"
        :labels="labels"
        :rows="rows"
        :clickable-rows="false"
        :loading-rows="5"
        :loading-cells="7"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.recent-activity-card {
  @apply bg-white rounded-xl border border-gray-200 overflow-hidden;
}
.header {
  @apply flex items-center justify-between px-4 sm:px-6 py-4 border-b border-gray-200;
  .title   { @apply font-semibold; }
  .subtitle{ @apply text-xs text-gray-500; }
}
.table-wrap { @apply px-2 sm:px-4 py-2; }

/* keep the inner scroller */
.ra-scroll {
  max-height: clamp(220px, 28vh, 420px);
  overflow: auto;

  /* hide scrollbar (cross-browser) */
  scrollbar-width: none;          /* Firefox */
  -ms-overflow-style: none;       /* IE/Edge legacy */
}
.ra-scroll::-webkit-scrollbar {   /* WebKit */
  width: 0;
  height: 0;
}

/* make table header sticky while the .ra-scroll container scrolls */
.ra-scroll :deep(thead) {
  position: sticky;
  top: 0;
  z-index: 1;
}
.ra-scroll :deep(thead th) {
  background: #fff;
  box-shadow: inset 0 -1px 0 rgba(0,0,0,0.06);
}

.ra-scroll :deep(table) {
  border-collapse: separate;
  border-spacing: 0;
}


</style>
